module.exports = __webpack_public_path__ + "assets/img/dialog-bg@3x.82e5b812.png";